import { TimelineEvent } from "../Types";

export const getPlayer = (timelineEvent: TimelineEvent, type?: string) => {
    if (!timelineEvent?.players?.length) {
        return undefined;
    }

    return type
        ? timelineEvent.players.filter((item) => item.type === type).shift()
        : timelineEvent.players[0];
};

export const getTimelineTitle = (timelineEvent: TimelineEvent) => {
    let extraTime;
    if (timelineEvent.stoppageTime) {
        extraTime = timelineEvent.stoppageTime;
    }
    return `${timelineEvent.matchTime}${extraTime ? `+${extraTime}` : ""}'`;
};
